import styled from "styled-components";

export const Wrapper = styled.div`
  border: 1px solid #e7e5e4;
  height: 100%;

  .rank-box {
    border: 1px solid rgba(145, 158, 171, 0.24);
    border-radius: 8px;
    padding: 8px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    overflow: visible;

    .rank-para {
      font-weight: 600;
      font-size: 12px;
      line-height: 22px;
      color: #637381;
      mix-blend-mode: normal;
      opacity: 0.72;
    }
    .rank-head {
      font-weight: 700;
      font-size: 20px;
      line-height: 36px;
      color: #212b36;
    }
    .rank-toggle-buttons {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      
      button {
        padding: 4px 12px;
        cursor: pointer;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        background: #fff;
        font-size: 12px;
        transition: all 0.3s;
        
        &:hover:not(:disabled) {
          border-color: #0ABAB5;
          color: #0ABAB5;
        }
        
        &:disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }
      
      span {
        font-size: 12px;
        color: #666;
      }
    }
  }

  .line-progress-container {
    .line-progress-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: -4px;
      .line-progress-title {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #212b36;
      }
      .line-progress-value {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        text-align: right;
        color: #212b36;
      }
    }
  }

  .liquid-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .ant-progress-text {
      font-weight: 700;
      font-size: 27px;
      text-align: center;
      color: #212b36;
    }
    .ant-progress-inner {
      width: 150px !important;
      height: 150px !important;
    }
  }
  /* @media (max-width: 1130px) {
    .responsive-rank {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .rank-container {
      padding-left: 0px;
      border-left: none;
    }
  } */

  .card-title {
    font-size: 18px;
    font-weight: 700;
  }
`;
